<template>
<!-- Desktop form -->
<div class="login">
<form class="login__form-home form__desktop desktop--form" method="post" :action="`//wager.${backendUrl}/DefaultLogin.aspx`">
    <h3>Log in</h3>

    <input type="hidden" name="siteID" id="siteID" :value="`${DGS_SITEID}`" />
    <input type="hidden" name="errorURL" :value="`//www.${backendUrl}/?login-error`" />

    <!-- User Name -->
    <div class="login__userName">
        <i class="fas fa-user-circle"></i>
        <label for="account">User Name:</label>
        <input class="login__form--inputs" type="text" placeholder="USERNAME" name="account" id="account">
    </div>

    <!-- Password -->
    <div class="login__password">
        <i class="fas fa-lock-alt"></i>
        <label for="password">Password:</label>
        <input class="login__form--inputs" type="password" name="password" placeholder="PASSWORD" id="password">
    </div>

    
    <div class="login__buttons">
        <button class="btn-login primary-button primary-button__loggin" type="submit">Login</button>
        <a href="#" class="btn-login primary-button primary-button__loggin" @click="openModal">Betslip</a>
    </div>
    </form>
    
    <form class="login__form-home form__desktop mobile--form" method="post" :action="`//mobile.${backendUrl}/DefaultLogin.aspx`">
    <h3>Log in</h3>

    <input type="hidden" name="siteID" id="siteID" :value="`${DGS_SITEID}`" />
    <input type="hidden" name="errorURL" :value="`//www.${backendUrl}/?login-error`" />

    <!-- User Name -->
    <div class="login__userName">
        <i class="fas fa-user-circle"></i>
        <label for="account">User Name:</label>
        <input class="login__form--inputs" type="text" placeholder="USERNAME" name="account" id="account">
    </div>

    <!-- Password -->
    <div class="login__password">
        <i class="fas fa-lock-alt"></i>
        <label for="password">Password:</label>
        <input class="login__form--inputs" type="password" name="password" placeholder="PASSWORD" id="password">
    </div>

    
    <div class="login__buttons">
        <button class="btn-login primary-button primary-button__loggin" type="submit">Login</button>
        <a href="#" class="btn-login secondary-button secondary-button__betslip" @click="openModal">Betslip</a>
    </div>
</form>
</div>


<ModalComponent ref="modal" />
</template>


<script>
import ModalComponent from '@/components/modal.vue'


export default {
name: "HeaderComponent",
components: {
    ModalComponent,
},
methods: {
    openModal() {
    this.$refs.modal.openModal();
    }
},
setup() {
    const DGS_SITEID = 983;
    const backendUrl = "tossandgo.live";

    return {
    DGS_SITEID,
    backendUrl,


    }
},
};
</script>
